import React from "react";
import { useParams, NavLink, Outlet } from "react-router-dom";
import styles from "./StockDetail.module.css";

const StockDetail = () => {
  const { id } = useParams();

  return (
    <div className={styles.container}>
      {/* 서브메뉴 (세로형 네비게이션) */}
      <nav className={styles.sidebar}>
        <ul>
          <li>
            <NavLink
              to={`/stocks/${id}/overview`}
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Overview
            </NavLink>
          </li>
          <li>
            <NavLink
              to={`/stocks/${id}/ceo`}
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              CEO Message
            </NavLink>
          </li>
          <li>
            <NavLink
              to={`/stocks/${id}/teaser`}
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Teaser
            </NavLink>
          </li>
          <li>
            <NavLink
              to={`/stocks/${id}/news`}
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              News
            </NavLink>
          </li>
          <li>
            <NavLink
              to={`/stocks/${id}/video`}
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Video Clip
            </NavLink>
          </li>
          <li>
            <NavLink
              to={`/stocks/${id}/chat`}
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              Chat
            </NavLink>
          </li>
        </ul>
      </nav>

      {/* 상세 페이지 내용 (라우팅) */}
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
};

export default StockDetail;
